module.exports = __webpack_public_path__ + "img/winter_23_lift_tickets-mobile.jpg";